module.exports = __webpack_public_path__ + "static/media/display.17ab7779.svg";